import { render, staticRenderFns } from "./DeleteMember.vue?vue&type=template&id=2fd998c6&scoped=true&"
import script from "./DeleteMember.vue?vue&type=script&lang=js&"
export * from "./DeleteMember.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMember.vue?vue&type=style&index=0&id=2fd998c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd998c6",
  null
  
)

export default component.exports